import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ASCService } from 'src/app/Services/AdminConfigurations/asc.service';
import { IAttributes } from 'src/app/models/IAttributes';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { Defaults } from 'src/app/Utilities/defaults';

@Component({
  selector: 'app-asc-consents',
  templateUrl: './asc-consents.component.html',
  styleUrls: ['./asc-consents.component.css'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),],

})
export class AscConsentsComponent implements OnInit {

  columnsToDisplay = ['attributeName', 'attributeDesc'];
  headercolumnsToDisplay = ['Template Name ', 'Description'];
  expandedElement: IAttributes | null;
  consentDetails:IAttributes[];
  consentData:IAttributes;
  templates:IAttributes[]; 
  show: boolean = false;
  ascconsentsform: FormGroup;
  submitted = false;

  showInfo() {
    this.expandedElement = null;
    this.clearForm();
    this.show = !this.show;  
  }

  constructor(private formBuilder: FormBuilder, private consentService: ASCService, 
    private toastr: ToastrService, private sharedservice: SharedService) {
    this.getConsentDetails();  
    this.getTemplateDetails();  
   }

  ngOnInit() {
    this.ascconsentsform = this.formBuilder.group({
      template: ['',],
      description: ['',]
    });
  }

  get f() { return this.ascconsentsform.controls; }

  onSubmit() {
    this.submitted = true;

    if (this.ascconsentsform.invalid) {
      return;
    }
  }

  getTemplateDetails()
  {
    this.sharedservice.getAttributesById(Defaults.ascTemplates).subscribe(data => {
      this.templates = data;
    });
  }

  getConsentDetails()
  {
    this.consentService.getConsentDetails().subscribe(data=>{
      this.consentDetails = data;
    })
  }

  addConsentDetails()
  {
    if (this.ascconsentsform.invalid) {
      return;
    }
    this.consentData = new IAttributes();
    this.consentData.attributeName = this.ascconsentsform.value.template;
    this.consentData.attributeDesc = this.ascconsentsform.value.description;
    this.consentData.createdBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.consentService.addConsentDetails(this.consentData).subscribe(data=>{
      this.toastr.success(data);
      this.getConsentDetails();
    })
    this.show = false;
    this.expandedElement = null;
  }

  updateConsentDetails(element:IAttributes)
  {
    if (this.ascconsentsform.invalid) {
      return;
    }
    this.consentData = new IAttributes();
    this.consentData.attributeName = this.ascconsentsform.value.template;
    this.consentData.attributeDesc = this.ascconsentsform.value.description;
    this.consentData.attributeId = element.attributeId;
    this.consentData.modifiedBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.consentService.addConsentDetails(this.consentData).subscribe(data=>{
      this.toastr.success(data);
      this.getConsentDetails();
    })
    this.show = false;
    this.expandedElement = null;
  }

  onCellClick(element:IAttributes){
    this.show=false;
    this.ascconsentsform.patchValue({
      template:element.attributeName,
      description:element.attributeDesc
    })
  }

  onCancelClick()
  {
    this.show=false;
    this.expandedElement=null;
  }

  clearForm()
  {
    this.ascconsentsform.reset();
  }
}
